document.addEventListener('DOMContentLoaded', () => {
  const cookiePreferenceSelectors = [...document.querySelectorAll('.edit-cookies-preferences')];
  cookiePreferenceSelectors.forEach(selector => {
    selector.addEventListener('click', event => {
      event.preventDefault();
      tarteaucitron.userInterface.openPanel();
    });
  });

  setTimeout(() => {
    const popin = document.getElementById('tarteaucitronAlertBig');

    if (popin && popin.style.display === 'block') {
      popin.style.display = 'none';
    }
  }, 20000);

  tarteaucitron.userInterface.respondAll =  (status, type, allowSafeAnalytics) => {
    "use strict";
    tarteaucitron.reloadThePage = true;
    var s = tarteaucitron.services,
      service,
      key,
      index = 0;
    for (index = 0; index < tarteaucitron.job.length; index += 1) {
      if (typeof type !== 'undefined' && type !== '' && s[tarteaucitron.job[index]].type !== type) {
        continue;
      }
      if (allowSafeAnalytics && typeof s[tarteaucitron.job[index]].safeanalytic !== "undefined" && s[tarteaucitron.job[index]].safeanalytic === true) {
        continue;
      }
      service = s[tarteaucitron.job[index]];
      key = service.key;
      if (tarteaucitron.state[key] !== status) {
        if (status === false && tarteaucitron.launch[key] === true) {
          tarteaucitron.reloadThePage = true;
        }
        if (tarteaucitron.launch[key] !== true && status === true) {
          tarteaucitron.pro('!' + key + '=engage');
          tarteaucitron.launch[key] = true;
          if (typeof tarteaucitronMagic === 'undefined' || tarteaucitronMagic.indexOf("_" + key + "_") < 0) { tarteaucitron.services[key].js(); }
          tarteaucitron.sendEvent(key + '_loaded');
        }
        tarteaucitron.state[key] = status;
        tarteaucitron.cookie.create(key, status);
        tarteaucitron.userInterface.color(key, status);
      }
    }
    window.location.reload();
  }

  tarteaucitron.userInterface.respond = function (el, status) {
    'use strict';
    if (el.id === '') {
      return;
    }
    var key = el.id.replace(new RegExp("(Eng[0-9]+|Allow|Deni)ed", "g"), "");

    if (key.substring(0, 13) === 'tarteaucitron' || key === '') {
      return;
    }

    // return if same state
    if (tarteaucitron.state[key] === status) {
      return;
    }

    tarteaucitron.reloadThePage = true;


    // if not already launched... launch the service
    if (status === true) {
      if (tarteaucitron.launch[key] !== true) {
        tarteaucitron.pro("!" + key + "=engage");

        tarteaucitron.launch[key] = true;
        tarteaucitron.sendEvent(key + "_loaded");
        if (
          typeof tarteaucitronMagic === "undefined" ||
          tarteaucitronMagic.indexOf("_" + key + "_") < 0
        ) {
          tarteaucitron.services[key].js();
        }
      }
    }
    tarteaucitron.state[key] = status;
    tarteaucitron.cookie.create(key, status);
    tarteaucitron.userInterface.color(key, status);

    const panel = document.getElementById('tarteaucitron');
    if (panel.style.display !== 'block') {
      tarteaucitron.userInterface.closePanel();
    }
  };

  const initSizeContainerFallback = elem => {
    if (elem.hasAttribute('height')) {
      elem.style.height = `${elem.getAttribute('height')}px`;
    }
    if (elem.hasAttribute('width')) {
      elem.style.width = `${elem.getAttribute('width')}px`;
    }
  };

  tarteaucitron.services.googletag = {
    key: 'googletag',
    type: 'api',
    name: Drupal.t('Google tag', {}, {context: 'tacjs'}),
    needConsent: true,
    cookies: [],
    js: function () {
      'use strict';
      tarteaucitron.reloadThePage = true;
    },
    fallback: function () {
      'use strict';
    }
  };
  (tarteaucitron.job = tarteaucitron.job || []).push('googletag');

  tarteaucitron.services.customvimeo = {
    key: 'customvimeo',
    type: 'video',
    name: 'Vimeo',
    needConsent: true,
    cookies: [],
    readmoreLink: '',
    js: function () {
      'use strict';
      tarteaucitron.reloadThePage = true;
    },
    fallback: function () {
      'use strict';

      tarteaucitron.fallback(['vimeo__container'], function (elem) {
        initSizeContainerFallback(elem);

        tarteaucitron.reloadThePage = true;
        return tarteaucitron.engage('customvimeo');
      });
    }
  };
  (tarteaucitron.job = tarteaucitron.job || []).push('customvimeo');

  tarteaucitron.services.customyoutube = {
    key: 'customyoutube',
    type: 'video',
    name: 'Youtube',
    readMoreLink: 'https://policies.google.com/privacy',
    needConsent: true,
    cookies: ['VISITOR_INFO1_LIVE', 'YSC', 'PREF', 'GEUP'],
    js: function () {
      'use strict';
      tarteaucitron.addScript('https://www.youtube.com/iframe_api');
    },
    fallback: function () {
      'use strict';

      tarteaucitron.fallback(['youtube_custom_container'], function (elem) {
        initSizeContainerFallback(elem);

        tarteaucitron.reloadThePage = true;
        return tarteaucitron.engage('customyoutube');
      });
    }
  };
  (tarteaucitron.job = tarteaucitron.job || []).push('customyoutube');

  tarteaucitron.services.other = {
    key: 'other',
    type: 'other',
    name: Drupal.t('Médias intégrés', {}, { context: 'tacjs' }),
    needConsent: true,
    cookies: [],
    js: function () {
      'use strict';
      tarteaucitron.reloadThePage = true;
    },
    fallback: function () {
      'use strict';
      tarteaucitron.fallback(['other-cookies__container'], function (elem) {
        initSizeContainerFallback(elem);

        return tarteaucitron.engage('other');
      });
    }
  };
  (tarteaucitron.job = tarteaucitron.job || []).push('other');

  tarteaucitron.services.addtoanyshare = {
    key: "addtoanyshare",
    type: "social",
    name: "AddToAny (share)",
    uri: "https://www.addtoany.com/privacy",
    needConsent: true,
    cookies: [],
    js: function () {
      "use strict";
      tarteaucitron.reloadThePage = true;
    },
    fallback: function () {
      "use strict";
      var id = "addtoanyshare";
      tarteaucitron.fallback(['addtoany_list', 'add_to_any_share__container'], tarteaucitron.engage(id));
    },
  };
  (tarteaucitron.job = tarteaucitron.job || []).push('addtoanyshare');

  tarteaucitron.services.customtwitter = {
    key: 'customtwitter',
    type: 'social',
    name: Drupal.t('Twitter', {}, { context: 'tacjs' }),
    needConsent: true,
    cookies: [],
    js: function () {
      'use strict';
      tarteaucitron.reloadThePage = true;
    },
    fallback: function () {
      'use strict';
      tarteaucitron.fallback(['twitter__container'], function (elem) {
        initSizeContainerFallback(elem);

        return tarteaucitron.engage('customtwitter');
      });
    }
  };
  (tarteaucitron.job = tarteaucitron.job || []).push('customtwitter');

  tarteaucitron.services.customsmartadserver = {
    key: 'customsmartadserver',
    type: 'api',
    name: 'Smart Ad Server',
    needConsent: true,
    cookies: [],
    readmoreLink: '',
    js: function () {
      'use strict';
      tarteaucitron.reloadThePage = true;
    },
    fallback: function () {
      'use strict';
    }
  };
  (tarteaucitron.job = tarteaucitron.job || []).push('customsmartadserver');

  tarteaucitron.services.customhelloasso = {
    key: 'customhelloasso',
    type: 'api',
    name: 'Hello Asso',
    needConsent: true,
    cookies: [],
    readmoreLink: '',
    js: function () {
      'use strict';
      tarteaucitron.reloadThePage = true;
    },
    fallback: function () {
      'use strict';
      tarteaucitron.fallback(['helloasso-wrapper'], function (elem) {
        initSizeContainerFallback(elem);

        return tarteaucitron.engage('customhelloasso');
      });
    }
  };
  (tarteaucitron.job = tarteaucitron.job || []).push('customhelloasso');

  const recaptchaJs = tarteaucitron.services.recaptcha.js;
  tarteaucitron.services.recaptcha.js = function () {
    const bodyElement = document.querySelector('body');
    if (bodyElement.hasAttribute('data-tacjs-recaptcha')) {
      return;
    }
    bodyElement.setAttribute('data-tacjs-recaptcha', true);

    recaptchaJs();
  };
  const recaptchaFallback = tarteaucitron.services.recaptcha.fallback;
  tarteaucitron.services.recaptcha.fallback = function () {
    const bodyElement = document.querySelector('body');
    if (bodyElement.hasAttribute('data-tacjs-recaptcha')) {
      return;
    }
    bodyElement.setAttribute('data-tacjs-recaptcha', true);

    recaptchaFallback();
  };
});
